import { render, staticRenderFns } from "./memberDetails.vue?vue&type=template&id=f6f44ff2&scoped=true&"
import script from "./memberDetails.vue?vue&type=script&lang=js&"
export * from "./memberDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f44ff2",
  null
  
)

export default component.exports